import { render } from "./CourseDetail.vue?vue&type=template&id=5c6247a0&scoped=true"
import script from "./CourseDetail.vue?vue&type=script&lang=js"
export * from "./CourseDetail.vue?vue&type=script&lang=js"

import "./CourseDetail.vue?vue&type=style&index=0&id=5c6247a0&lang=less&scoped=true"

import exportComponent from "D:\\workbuddy\\LaiShanKeHou\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c6247a0"]])

export default __exports__